import React from 'react';
import { useTranslation } from 'react-i18next';

import { SubPage, IconAsButton, ListTable, Typo, Loading } from '../../../ui';
import { CONTENT_MINI } from '../../../utils/media';
import { useDiplomaList } from '../../diploma/hooks/useDiplomaState';
import { useDiplomaActions } from '../../diploma/hooks/useDiplomaActions';

const ProfileDiplomas = () => {
  const { t } = useTranslation();

  const { diplomas: diplomaList, isLoading } = useDiplomaList();

  const { downloadDiploma, emailDiploma } = useDiplomaActions();

  const downloadPDF = (pdf) => {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = 'diploma.pdf';

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const emailMeDiploma = async (courseId) => {
    await emailDiploma({ courseId });
  }

  const handleDownloadDiploma = async (courseId) => {
    const result = await downloadDiploma({ courseId });
    downloadPDF(result);
  }

  const tableInfo = [
    { label: t('globals.course'), data: (item) => item.courseName },
    {
      label: t('profile.download'),
      data: (item) =>
        <IconAsButton clickHandle={(e) => handleDownloadDiploma(item.courseId)} iconName='Download' tooltipLabel={t('profile.download')} />
    },
    {
      label: t('profile.emailMe'),
      data: (item) =>
        <IconAsButton clickHandle={(e) => emailMeDiploma(item.courseId)} iconName='Email' tooltipLabel={t('profile.sendBy')} />
    },
  ]

  return (
    <SubPage size={CONTENT_MINI} align='flex-start' >
      {isLoading ? <Loading />
        : !!diplomaList.length ? <ListTable
          tableInfo={tableInfo}
          data={diplomaList}
          tableName={'diplomas'}
        />
          : <Typo.BigText>{t('profile.noDiploma')}</Typo.BigText>}
    </SubPage >
  );
};

export default ProfileDiplomas;
